<div class="toast-stack" aria-live="polite" aria-atomic="false">
  @for (t of toasts(); track t.id) {
    <div
      class="toast toast--{{ t.type }}"
      role="status"
    >
      <span class="toast__icon">
        <app-icon [icon]="iconFor(t.type)" [size]="20" color="currentColor" />
      </span>
      <div class="toast__body">
        <p class="toast__message">{{ t.message }}</p>
        @if (t.actions?.length) {
          <div class="toast__actions">
            @for (action of t.actions; track action.label) {
              <button type="button" class="toast__action" (click)="onAction(t.id, action)">
                {{ action.label }}
              </button>
            }
          </div>
        }
      </div>
      <button
        type="button"
        class="toast__close"
        aria-label="Cerrar notificación"
        (click)="onDismiss(t.id)"
      >
        <app-icon [icon]="closeIcon" [size]="16" color="currentColor" />
      </button>
    </div>
  }
</div>
